

export const documents = [
    { nom: "Acte de mariage / pacs - acheteur", destinataire:"acheteur" },
    { nom: "Acte de mariage / pacs - vendeur", destinataire:"vendeur" },
    { nom: "Acte de naissance - vendeur",destinataire:"vendeur" },
    { nom: "Acte de naissance - acheteur",destinataire:"acheteur"  },
    { nom: "Amiante - L’état relatif à l’amiante",destinataire:"vendeur"  },
    { nom: "Appels de charges des 3 dernières années",destinataire:"vendeur"  },
    { nom: "Arrêté de PC (ou de DP)",destinataire:"vendeur"  },
    { nom: "Attestation de décennale",destinataire:"vendeur"  },
    { nom: "Attestation d’ADO",destinataire:"vendeur"  },
    { nom: "Audit énergétique",destinataire:"vendeur"  },
    { nom: "Certificat d’immatriculation",destinataire:"vendeur"  },
    { nom: "Contrôle assainissement individuel",destinataire:"vendeur"  },
    { nom: "Contrôle d’assainissement collectif (tout-à-l’égout)",destinataire:"vendeur"  },
    { nom: "Copie complète du livret de famille - vendeur",destinataire:"vendeur"  },
    { nom: "Copie complète du livret de famille - acheteur",destinataire:"acheteur"  },
    { nom: "Copie de la simulation de prêt",destinataire:"acheteur"  },
    { nom: "Copie de jugement de divorce - acheteur",destinataire:"vendeur"  },
    { nom: "Copie de jugement de divorce - vendeur",destinataire:"acheteur"  },
    { nom: "DAACT",destinataire:"vendeur"  },
    { nom: "DPE - Le diagnostic de performance énergétique",destinataire:"vendeur"  },
    { nom: "DTA parties communes",destinataire:"vendeur"  },
    { nom: "DTG",destinataire:"vendeur"  },
    { nom: "Dernier avis d’imposition au titre de la taxe foncière",destinataire:"vendeur"  },
    { nom: "Dossier de dépôt de PC / DP",destinataire:"vendeur"  },
    { nom: "Electrique - EIIE - L’état de l’installation intérieure d’électricité",destinataire:"vendeur"  },
    { nom: "Etude financement acquéreur",destinataire:"vendeur"  },
    { nom: "Factures d’entreprise",destinataire:"vendeur"  },
    { nom: "Fiche synthétique",destinataire:"vendeur"  },
    { nom: "Gaz - EIIG - L’état de l’installation intérieure de gaz",destinataire:"vendeur"  },
    { nom: "Le carnet d'entretien de l'immeuble",destinataire:"vendeur"  },
    { nom: "Le(s) titre(s) de propriété du bien vendu (actes d’acquisition, de donation, attestation de propriété après décès...)",destinataire:"vendeur"  },
    { nom: "Liste du mobilier (détaillée article par article avec leur valeur)",destinataire:"vendeur"  },
    { nom: "L’état des risques naturels, miniers et technologiques",destinataire:"vendeur"  },
    { nom: "Mandat de vente",destinataire:"vendeur"  },
    { nom: "Merules - L’état relatif à la présence ou non de mérules",destinataire:"vendeur"  },
    { nom: "Offre d'achat",destinataire:"acheteur"  },
    { nom: "PV d’AG des 3 dernières années",destinataire:"vendeur"  },
    { nom: "Papier identité - acheteur",destinataire:"acheteur"  },
    { nom: "Papier identité - vendeur",destinataire:"vendeur"  },
    { nom: "Plan cadastral",destinataire:"vendeur"  },
    { nom: "Plan du lot vendu",destinataire:"vendeur"  },
    { nom: "Plomb - Le constat des risques d’exposition au plomb (CREP)",destinataire:"vendeur"  },
    { nom: "Procès-verbaux des assemblées générales des copropriétaires des trois dernières années",destinataire:"vendeur"  },
    { nom: "Pré-état daté",destinataire:"vendeur"  },
    { nom: "RCP-EDD",destinataire:"vendeur"  },
    { nom: "Règlement de copropriété et tous ses modificatifs",destinataire:"vendeur"  },
    { nom: "Superficie Carrez",destinataire:"vendeur"  },
    { nom: "Termite - L’état relatif à la présence de termites et autres insectes xylophages",destinataire:"vendeur" }
];